import { CountryCodeEnum } from "@shared/enums/country.enum";

export function currencyUser(countryCode: string | CountryCodeEnum) {
  let currency = "R$";
  switch (countryCode) {
    case CountryCodeEnum.ARGENTINA:
      currency = "ARS";
      break;
    case CountryCodeEnum.UNITED_STATES:
      currency = "$";
      break;
  }
  return currency;
}
